import {makeGet} from '@yandex-delivery/utils'

import type {PaymentMethodContract, PaymentMethodFinance, PaymentMethodsListResponse} from '../types'

export const paymentMethodsListGetter = makeGet<PaymentMethodsListResponse>()
export const paymentMethodFinanceGetter = makeGet<PaymentMethodFinance>()
export const paymentMethodContractGetter = makeGet<PaymentMethodContract>()
